import { render, staticRenderFns } from "./overviewArea.vue?vue&type=template&id=b6a3c2d6&scoped=true&"
import script from "./overviewArea.vue?vue&type=script&lang=js&"
export * from "./overviewArea.vue?vue&type=script&lang=js&"
import style0 from "./overviewArea.vue?vue&type=style&index=0&id=b6a3c2d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a3c2d6",
  null
  
)

export default component.exports